import { useMemo } from "react"
import { useQuery } from "urql"

import {
  GetVendorDefaultExpenseAccountByIdDocument,
  type GlAccount,
  type GlAccountQueryListArgs,
  type Query,
} from "@/graphql/codegen/graphql"

interface UseResolveGlAccountByIdReturn {
  glAccount: GlAccount | null
  isFetching: boolean
}

const SINGLE_RECORD_LIMIT = 1

export const useResolveGlAccountById = (id: string | null | undefined): UseResolveGlAccountByIdReturn => {
  const [{ data, fetching }] = useQuery<Pick<Query, "glAccount">, GlAccountQueryListArgs>({
    query: GetVendorDefaultExpenseAccountByIdDocument,
    variables: {
      input: {
        filter: {
          glAccountIds: id ? [id] : undefined,
        },
        offset: 0,
        limit: SINGLE_RECORD_LIMIT,
      },
    },
    pause: !id,
  })

  const glAccount = useMemo<GlAccount | null>(() => {
    if (data?.glAccount.list.__typename !== "GlAccountListSuccess") return null

    const account = data.glAccount.list.glAccounts.find((entry) => entry !== null)
    return account ?? null
  }, [data])

  return { glAccount, isFetching: fetching }
}
